<script setup lang="ts">
  import { computed } from 'vue';
  import type { ChatBgShapeConfig } from '@/models/chat';

  const props = defineProps({
    color1: {
      type: String,
      required: true
    },
    color2: {
      type: String,
      required: true
    },
    isChameleonMode: {
      type: Boolean,
      default: false
    }
  });

  const chameleonMode = computed(() => props.isChameleonMode);

  const shapeConfig: ChatBgShapeConfig = {
    initialStart: {
      top: 194.15,
      left: 369.14,
      width: 261.005,
      height: 570.591,
      rotation: -113.23,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    initialEnd: {
      top: 346.26,
      left: 465.35,
      width: 291.308,
      height: 462.193,
      rotation: 55.804,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    },
    chameleonStart: {
      top: 242.68,
      left: 661.58,
      width: 409.178,
      height: 964.869,
      rotation: 90.777,
      duration: 2,
      repeat: 0,
      yoyo: false,
      ease: 'power1.inOut'
    },
    chameleonEnd: {
      top: 113.38,
      left: 479.81,
      width: 363,
      height: 584,
      rotation: -151,
      duration: 15,
      repeat: -1,
      yoyo: true,
      ease: 'power1.inOut'
    }
  };

  const { svgRef } = useChatBgShape(chameleonMode, shapeConfig);
</script>

<template>
  <svg
    ref="svgRef"
    :class="['chat-bg-shape', 'chat-bg-shape--5', { chameleon: chameleonMode }]"
    :style="{ '--chat-bg-color-1': color1, '--chat-bg-color-2': color2 }"
    width="261"
    height="571"
    viewBox="0 0 261 571"
    xmlns="http://www.w3.org/2000/svg">
    <ellipse
      cx="130.502"
      cy="285.296"
      rx="130.502"
      ry="285.296"
      fill="url(#paint0_radial_7_8)" />
    <defs>
      <radialGradient
        id="paint0_radial_7_8"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(25.4598 507.502 -1262.9 -231.54 127.325 112.213)"
        gradientUnits="userSpaceOnUse">
        <stop
          class="color1"
          offset="0" />
        <stop
          class="color2"
          offset="1" />
      </radialGradient>
    </defs>
  </svg>
</template>
